<template>
  <notifications width="100%" position="top left">
    <Card slot="body" slot-scope="props" class="wrap">
      <div class="body" @click="props.close">
        {{props.item.text}}
      </div>
    </Card>
  </notifications>
</template>

<script>
import Card from '@/components/atoms/Card'

export default {
  name: 'ProxyNotifications',
  components: {
    Card,
  },
}
</script>

<style scoped lang="scss">
.wrap {
  margin: 8px 8px 0;
  color: $primary;
  border: 3px solid;
  background: rgba(255, 255, 255, 0.8);
}

.body {
  font-size: 12px;
  font-weight: bold;
  padding: 12px 17px;
}
</style>

